

// @ts-ignore
import { EventEmitter } from '@billjs/event-emitter';

export class Search {

	private trigger: HTMLButtonElement;
	private searchPanel: HTMLElement;
	private emitter: any;


	constructor() {
		this.emitter     = new EventEmitter();
		this.trigger     = document.querySelector('.search-btn');
		this.searchPanel = document.querySelector('.search-panel');

		if ( this.trigger ) {
			this.trigger.addEventListener( 'click', () => {
				if ( this.trigger.classList.contains( 'active' ) ) {
					this.closeSearch();
					this.emitter.fire('search_close');
				} else {
					this.openSearch();
					this.emitter.fire('search_open');
				}
			});
		}
	}


	openSearch() {
		document.body.classList.add('search-open');
		this.trigger.classList.add('active');

		if ( this.searchPanel ) {
			this.searchPanel.classList.add('slide_in');
		}
	}


	closeSearch( ev?: MouseEvent ) {
		document.body.classList.remove('search-open');
		this.trigger.classList.remove('active');

		if ( this.searchPanel ) {
			this.searchPanel.classList.remove('slide_in');
		}
	}

}